import Tooltip from "@mui/material/Tooltip";
import { useEffect, useRef, useState } from "react";

const NodeLabel = ({ whatNode, isLabel }) => {
  const { label, customLabel, componentKey, variable_reference } = whatNode || {};
  const lblClass = `custom-node-text`;
  const variableReferenceName = variable_reference?.split(".").pop();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const keyRef = useRef(null);

  useEffect(() => {
    if (keyRef.current) {
      const el = keyRef.current;
      const overflow = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
      setIsOverflowing(overflow);
    }
  }, [componentKey, variable_reference]);

  if (isLabel) return null;

  const componentKeyElement = (
    <p ref={keyRef} className="component-key">
      ({componentKey})
    </p>
  );

  const variableReferenceElement = variableReferenceName ? (
    <p className="component-variable-reference">({variableReferenceName})</p>
  ) : null;

  return (
    <div className={lblClass}>
      <p className="label-text">{customLabel || label}</p>
      {componentKey &&
        (isOverflowing ? (
          <Tooltip title={componentKey} placement="bottom" arrow>
            {componentKeyElement}
          </Tooltip>
        ) : (
          componentKeyElement
        ))}
      {variableReferenceElement}
    </div>
  );
};

export default NodeLabel;
